// @ts-check
import React, { useEffect, useState } from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Button from '@liquidweb-dev/undercurrent/Button';
import Dialog from '@liquidweb-dev/undercurrent/Dialog';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import useAccountDetails from 'modules/queries/account/useDetails';
import useUserMetaState from 'modules/queries/account/user/stateData/useUserMetaState';
import accountStatuses from 'utility/constants/accountStatuses';

const DialogNewPortalWelcome = () => {
	const [isOpen, setIsOpen] = useState(false);

	const {
		data: accountDetails,
		isLoading: isAccountDetailsLoading,
		isError: isAccountDetailsError,
	} = useAccountDetails({});

	const isActiveAccount =
		accountDetails?.account_status === accountStatuses.ACTIVE;
	const [
		isDismissed,
		setIsDismissed,
		{ isLoading: isDismissedLoading, isError: isDismissedError },
	] = useUserMetaState('newPortalWelcomeDismissed', false);

	const isLoading = isAccountDetailsLoading || isDismissedLoading;
	const isError = isAccountDetailsError || isDismissedError;

	// open the dialog if the user has not seen it yet
	useEffect(() => {
		if (isLoading || isError || isDismissed || !isActiveAccount) return;

		setIsOpen(true);
	}, [isError, isLoading, isDismissed, isActiveAccount]);

	if (isLoading || isDismissed) {
		return null;
	}

	/** @param {string} [reason] */
	const handleClose = (reason) => {
		if (reason === 'backdropClick') {
			return;
		}
		setIsOpen(false);
		setIsDismissed(true);
	};

	return (
		<Dialog
			open={isOpen}
			onClose={(event, reason) => handleClose(reason)}
			maxWidth="md"
			fullWidth
		>
			<Box
				component="video"
				sx={{
					width: '100%',
					objectFit: 'cover',
				}}
				controls
			>
				<source
					src="https://www.liquidweb.com/wp-content/uploads/2025/04/myliquidweb_april_update.webm"
					type="video/webm"
				/>
			</Box>

			<Stack
				sx={{ gap: 300, padding: { xs: 200, sm: 500 }, alignItems: 'center' }}
			>
				<Stack sx={{ gap: 100 }}>
					<Typography
						variant="title-xs"
						sx={{ fontWeight: 500, textAlign: 'center' }}
					>
						A fresh new look for your portal
					</Typography>
					<Typography
						variant="body-sm"
						sx={{ textAlign: 'center', maxWidth: '703px' }}
					>
						We’re rebuilding the portal from the ground up with a cleaner
						design, smarter navigation, and easier access to the tools you use
						every day. It’s the same power under the hood, now with a smoother,
						more focused experience. This is just the beginning — more updates
						are on the way.
					</Typography>
				</Stack>

				<Button onClick={() => handleClose()}>I got it</Button>
			</Stack>
		</Dialog>
	);
};

export default DialogNewPortalWelcome;
